/**
 * Mobile Menu Toggle
 */

/**
 * #page-open-mobile-menu  ==> mobile-menu-trigger
 *
 *
 */
/* $('#page-open-mobile-menu').on('click', function (e) {
    e.preventDefault();
    openMobileMenu();
}); */
const $body = document.querySelector('body');
const $html = document.documentElement;
const mobileMenuTrigger = document.querySelector('.mobile-menu-trigger');
const mobileMenuClose = document.querySelector('.close-mobile-menu ');
mobileMenuTrigger.addEventListener('click', (e) => {
    e.preventDefault;
    $body.classList.add('menu-opened')
    $html.style.overflow = 'hidden'
})
mobileMenuClose.addEventListener('click', (e) => {
    e.preventDefault;
    $body.classList.remove('menu-opened')
    $html.style.overflow = ''
})

jQuery(function ($) {
    const menu = document.getElementById('mobile-menu');
    $(menu).on('click', '.toggle-sub-menu', function (e) {
        var _li = $(this).parents('li').first();
        e.preventDefault();
        e.stopPropagation();
        var _friends = _li.siblings('.opened');
        _friends.removeClass('opened');
        _friends.find('.opened').removeClass('opened');
        _friends.find('.sub-menu').stop().slideUp();
        if (_li.hasClass('opened')) {
            _li.removeClass('opened');
            _li.find('.opened').removeClass('opened');
            _li.find('.sub-menu').stop().slideUp();
        } else {
            _li.addClass('opened');
            _li.children('.sub-menu').stop().slideDown();
        }
    });

})//jQu
